import type { GameProduct, TagsType } from '@patrianna/shared-patrianna-types/store/GameModule'
import { useMemo } from 'react'

import ProductGameTile from 'containers/ProductGameTile'
import useGames from 'src/hooks/useGames'
import { hasTag } from 'utils/gameTags'

export type Props = {
  tag: TagsType
}

export default function GamesByTagContainer(props: Props) {
  const { allVisibleGames = [] } = useGames()

  const filteredGameTiles = useMemo(() => {
    const filteredGames = allVisibleGames.filter((item: GameProduct) => hasTag(item.tags, props.tag))

    return filteredGames.map((item, index) => <ProductGameTile game={item} gameIndex={index + 1} key={item.code} />)
  }, [allVisibleGames, props.tag])

  return <div className='grid items-start gap-2 px-4 pb-4 grid-cols-3 lg:grid-cols-5'>{filteredGameTiles}</div>
}
